import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type PreferenceStore = {
  hasSeenRosterWhatsNew: boolean;
  setHasSeenRosterWhatsNew: (value: boolean) => void;
  hasSeenStudentSwitcherWhatsNew: boolean;
  setHasSeenStudentSwitcherWhatsNew: (value: boolean) => void;
};

export const preferenceStore = create<PreferenceStore>()(
  persist(
    (set) => ({
      hasSeenRosterWhatsNew: false,
      setHasSeenRosterWhatsNew: (value) => set({ hasSeenRosterWhatsNew: value }),
      hasSeenStudentSwitcherWhatsNew: false,
      setHasSeenStudentSwitcherWhatsNew: (value) => set({ hasSeenStudentSwitcherWhatsNew: value }),
    }),
    { name: 'preferenceStorage' },
  ),
);
